import { createAsyncAction, action } from 'typesafe-actions';
import { HttpStatus } from 'client/ErrorHandler';
import { UploadTypes, UploadRequestPayload } from './types';

const uploadActions = createAsyncAction(
  UploadTypes.UploadRequest,
  UploadTypes.UploadSuccess,
  UploadTypes.UploadFailure
)<UploadRequestPayload, undefined, HttpStatus>();

export const uploadReset = () => action(UploadTypes.UploadReset);

export default uploadActions;
